export default __webpack_public_path__ + "static/media/signal.218cfa38.svg";